/**
 * @file
 * @author zhousheng
 */
import Select, { ExportedSelectProps as SelectProps } from './Select';
import { RefSelectProps } from './generate';
import Option from './Option';
import OptGroup from './OptGroup';
export { Option, OptGroup, SelectProps, RefSelectProps };
export default Select;
